import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { FC } from 'react';

export const BillingSubscriptionsPreloader: FC<{ rows?: number }> = ({ rows = 10 }) => (
  <Box sx={{ py: 3 }}>
    <Box sx={{ borderRadius: 2, border: theme => `1px solid ${theme.palette.divider}`, overflow: 'hidden' }}>
      <Table>
        <TableHead>
          <TableRow>
            {['Subscription', 'Status', 'Product', 'Next Payment', 'Total', ''].map(header => (
              <TableCell key={header} sx={{ bgcolor: 'grey.200', fontWeight: 700 }}>
                {header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from({ length: rows }).map((_, i) => (
            // oxlint-disable-next-line react/no-array-index-key
            <TableRow key={i}>
              <TableCell>
                <Skeleton variant="text" width={80} />
              </TableCell>
              <TableCell>
                <Skeleton variant="rounded" width={72} height={24} />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width={160} />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width={120} />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width={56} />
              </TableCell>
              <TableCell align="right">
                <Skeleton variant="rounded" width={72} height={32} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  </Box>
);
